// @flow
import React from 'react'
import styles from './md-page.module.scss'

interface Props {
  children: React.ReactNode
}

const Page = ({ children }: Props) => (
  <div className={styles.pages}>{children}</div>
)

export default Page
